export class LayerComposite {
	constructor(width, height, groundOffset, speedModifire, game) {
		this.game = game;
		this.groundOffset = this.game.ground2.y;
		this.startWidth = width;
		this.startHeight = height;
		this.width = width;
		this.height = height;
		this.x = 0;
		this.y = this.game.ground2.y - this.height;
		this.x2 = this.width;
		this.images = document.querySelectorAll('.bg-layerces');
		this.speedModifire = speedModifire;
		this.speed = this.game.speed * this.speedModifire;
		this.activeImage = 0;
	}

	update() {
		this.x -= this.speed;

		if (this.x < 0 - this.width) {
			this.x = 0;

			if (this.activeImage < this.images.length - 1) {
				this.activeImage++;
			} else {
				this.activeImage = 0;
			}
		}
	}

	draw() {
		this.game.ctx.drawImage(this.images[this.activeImage], this.x, this.y, this.width, this.height);
		this.game.ctx.drawImage(
			this.images[
				this.activeImage + 1 !== this.images.length ? this.activeImage + 1 : 0
			], this.x + this.width - 1, this.y, this.width, this.height,
		);
	}

	resize() {
		// this.x = this.startX;
		this.y = this.game.ground2.y - this.height;
		this.width = this.startWidth;
		this.height = this.startHeight;
		// this.x2 = this.width;
	}
}
